import { useMemo } from 'react';
import clsx from 'clsx';
import sanitizeHtml from 'sanitize-html';

import styles from './quill-html-renderer.module.scss';

export const HTMLRenderer = ({
  dangerouslySetInnerHTML,
  className,
  ...props
}) => {
  const html = dangerouslySetInnerHTML.__html;

  const sanitizedDesc = useMemo(() => {
    return html
      ? sanitizeHtml(html, {
          parseStyleAttributes: true,
          allowedAttributes: {
            '*': ['style'],
            a: ['href', 'target', 'rel'],
            li: ['data-list'],
          },
        })
      : null;
  }, [html]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedDesc }}
      className={clsx(className, styles.container)}
      {...props}
    />
  );
};
